import { lazy } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router'
import { Layout, NotFound } from './features/common'
import { AuthDropdown } from './features/auth'

const HomeScreen = lazy(() =>
  import(/* webpackPrefetch: true */ './features/home').then((m) => ({ default: m.HomeScreen }))
)
const ArticleList = lazy(() =>
  import(/* webpackPrefetch: true */ './features/article').then((m) => ({ default: m.ArticleList }))
)
const PageList = lazy(() =>
  import(/* webpackPrefetch: true */ './features/page').then((m) => ({ default: m.PageList }))
)
const LayoutPreviewScreen = lazy(() =>
  import(/* webpackPrefetch: true */ './features/layout').then((m) => ({ default: m.LayoutPreviewScreen }))
)
const SubLayoutList = lazy(() =>
  import(/* webpackPrefetch: true */ './features/subLayout').then((m) => ({ default: m.SubLayoutList }))
)
const GroupList = lazy(() =>
  import(/* webpackPrefetch: true */ './features/group').then((m) => ({ default: m.GroupList }))
)
const UserList = lazy(() =>
  import(/* webpackPrefetch: true */ './features/user').then((m) => ({ default: m.UserList }))
)
const MediaList = lazy(() =>
  import(/* webpackPrefetch: true */ './features/media').then((m) => ({ default: m.MediaList }))
)
const MediaEngineStats = lazy(() =>
  import(/* webpackPrefetch: true */ './features/media').then((m) => ({ default: m.MediaEngineStats }))
)
const SettingList = lazy(() =>
  import(/* webpackPrefetch: true */ './features/media').then((m) => ({ default: m.SettingList }))
)
const SettingConfig = lazy(() =>
  import(/* webpackPrefetch: true */ './features/media').then((m) => ({ default: m.SettingConfig }))
)
const LayoutDebugScreen = lazy(() =>
  import(/* webpackPrefetch: true */ './features/layoutDebug').then((m) => ({ default: m.LayoutDebugScreen }))
)
const AdminRoute = lazy(() =>
  import(/* webpackPrefetch: true */ './features/admin').then((m) => ({ default: m.AdminRoute }))
)
const MonthlyEngineStats = lazy(() =>
  import(/* webpackPrefetch: true */ './features/admin').then((m) => ({ default: m.MonthlyEngineStats }))
)

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route
        path='/'
        element={
          <Layout>
            <AuthDropdown />
          </Layout>
        }
      >
        <Route index element={<HomeScreen />} />
        <Route path='pages' element={<PageList />} />
        <Route path='pages/:pageId/articles' element={<ArticleList />} />
        <Route path='pages/:pageId/layout' element={<LayoutPreviewScreen />} />
        <Route path='sub_layouts' element={<SubLayoutList />} />
        <Route path='sub_layouts/:subLayoutId/articles' element={<ArticleList layoutableType='SubLayout' />} />
        <Route path='sub_layouts/:subLayoutId/layout' element={<LayoutPreviewScreen layoutableType='SubLayout' />} />
        <Route path='groups' element={<GroupList />} />
        <Route path='users' element={<UserList />} />
        <Route path='media' element={<MediaList />} />
        <Route path='media/:mediaId/engineStats' element={<MediaEngineStats />} />
        <Route path='settings' element={<SettingList />} />
        <Route path='settings/:settingId' element={<SettingConfig />} />
        <Route path='layout_debug' element={<LayoutDebugScreen />} />
        <Route path='admin' element={<AdminRoute />}>
          <Route path='monthly_engine_stats' element={<MonthlyEngineStats />} />
        </Route>
        <Route path='*' element={<NotFound />} />
      </Route>
    </Routes>
  </BrowserRouter>
)

export default App
